const getters = {
  loadingAgents: (state) => state.loading,
  agents: (state) => state.agents,
  error: (state) => state.error,
  matchingAgents: (state) => state.matchingAgents,
  matchingAgentsSortedByType: (state) => {
    const sortedAgents = {}
    state.matchingAgents.forEach(agent => {
      if (!sortedAgents[agent.type_field]) {
        sortedAgents[agent.type_field] = [agent]
      } else {
        sortedAgents[agent.type_field].push(agent)
      }
    })
    return sortedAgents
  },
  selectedAgent: (state) => state.selected,
  agentUrlBySlug: (slug) => (state) => {
    const matchingAgent = state.agents.find(agent => agent.slug === slug)
    return matchingAgent ? matchingAgent.url : null
  },
  agentProtections: (state) => state.selected ? state.selected.ppes : [],
  agentDecontaminations: (state) => state.selected ? state.selected.decontaminations : [],
  agentFireFighting: (state) => {
    if (!state.selected || state.selected.firefightingmeasure === null) {
      return {}
    }
    return state.selected.firefightingmeasure
  },
  agentFireDiamond: (state) => state.selected ? state.selected.nfpafirediamond : null,
  agentEvacuation: (state) => state.selected ? state.selected.cordons : [],
  agentSymptoms: (state) => state.selected ? state.selected.symptoms : [],
  agentDetectors: (state) => state.selected ? state.selected.detectors : [],
  agentSamplingTypes: (state) => state.selected ? state.selected.sampling_types : [],
  agentStatements: (state) => state.selected ? state.selected.statements : [],
  agentPictograms: (state) => state.selected ? state.selected.pictograms : [],
  agentSynonyms: (state) => state.selected ? state.selected.synonyms : [],
}

export default getters
